import React from 'react'
import { RealEstateDataPageComponentData } from 'types'
import HandleFilters from '@components/handleFilterBar/1'

const Filters1Component_v1_0_1 = (props: RealEstateDataPageComponentData) => {
  const idsPredefinidos = [
    3, 2, 0, 1, 5, 7, 8, 6, 9, 4, 11, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
  ]
  return (
    <HandleFilters
      idsPredefinidos={idsPredefinidos}
      {...props}
    />
  )
}

export default Filters1Component_v1_0_1
